import { Box, Stack } from "@adfenix/alexandria";
import Page from "components/Page";
import PageHeader from "components/PageHeader";
import { ColumnSearch } from "components/ReadLayer/ColumnSearch";
import { DateRange } from "components/ReadLayer/DateRange";
import { ReadLayerWrapper } from "components/ReadLayer/ReadLayerWrapper";
import { ResetButton } from "components/ReadLayer/ResetButton";
import { SearchField } from "components/ReadLayer/SearchField";
import { Col, Row } from "react-grid-system";
import { CampaignTable } from "./CampaignTable";
import { useRecoilValue } from "recoil";
import { userSelectedHq } from "atoms/auth";
import { useSearchParams } from "react-router-dom";
import { OneCustomerCampaignTable } from "./OneCustomerCampaignTable";

export const CampaignsPage = () => {
  const selectedHq = useRecoilValue(userSelectedHq);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const hqId = selectedHq?.id;
  const isShowOneCampaign = hqId! && id!;

  return (
    <Page
      fullWidth
      header={
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <PageHeader title="Campaigns" />
        </Box>
      }
    >
      <ReadLayerWrapper
        serviceName="read-layer"
        indexName="customer-campaign-overview"
        sortOnColumn="created"
        filters={
          isShowOneCampaign
            ? [{ column: "id", value: id }]
            : [{ column: "hq.id", value: selectedHq?.id ?? "" }]
        }
        sortAscending={false}
        subscribeToPropUpdates
      >
        {isShowOneCampaign ? (
          <OneCustomerCampaignTable />
        ) : (
          <Stack spacing="m" alignItems="center">
            <SearchField
              minWidth={700}
              placeholder="Search: Property id, Landing Page, Bundle name, Bundle type, Address, Advertiser Email"
              columns={[
                "id",
                "campaignTemplateName",
                "mergedBundleProduct.name",
                "property.location.address",
                "property.id",
                "agents.email"
              ]}
            />

            <Row>
              <Box
                display="flex"
                alignItems="center"
                style={{ marginLeft: 16 }}
              >
                Filter by:
              </Box>
              <Col>
                <Box display="flex" justifyContent="center">
                  <DateRange column="created" placeholder="Create date" />
                </Box>
              </Col>
              <Col>
                <ColumnSearch
                  column="displayCustomerFacingStatus"
                  placeholder="All Statuses"
                />
              </Col>

              <Col>
                <ColumnSearch
                  column="bundle.programName"
                  placeholder="Programs"
                  filterColumn="hq.id"
                />
              </Col>
              <Col>
                <ColumnSearch
                  column="office.displayName"
                  placeholder="Search all offices"
                  filterColumn="hq.id"
                />
              </Col>
              <Col>
                <ColumnSearch
                  column="agents.email"
                  placeholder="Search all agents (by email)"
                  filterColumn="hq.id"
                />
              </Col>

              <Box
                display="flex"
                justifyContent="end"
                style={{ marginRight: 16 }}
              >
                <ResetButton />
              </Box>
            </Row>
            <CampaignTable />
          </Stack>
        )}
      </ReadLayerWrapper>
    </Page>
  );
};
